import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

export const SidebarContainer = styled.aside`
  position: fixed;
  top: 0;
  left: 0;
  width: 280px;
  height: 100vh;
  background: linear-gradient(180deg, #2B3857 0%, #1a2332 100%);
  backdrop-filter: blur(20px);
  border-right: 1px solid rgba(197, 51, 123, 0.2);
  z-index: 1000;
  transition: transform 0.3s ease;
  overflow-y: auto;
  box-shadow: 4px 0 20px rgba(0, 0, 0, 0.1);

  /* All screens: Collapsible */
  transform: ${props => props.isOpen ? 'translateX(0)' : 'translateX(-100%)'};

  /* Mobile: Full width sidebar */
  @media (max-width: 768px) {
    width: 100%;
    max-width: 280px;
  }
`;

export const SidebarHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.5rem 1rem;
  border-bottom: 1px solid rgba(197, 51, 123, 0.15);
`;

export const Logo = styled.h2`
  color: #ffffff;
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
`;

export const ToggleButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  color: #ffffff;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 8px;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(43, 56, 87, 0.2);
  }
`;

export const Navigation = styled.nav`
  padding: 1rem 0;
`;

export const NavItem = styled.div`
  margin: 0.25rem 0;
`;

export const NavLinkStyled = styled(NavLink)`
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  color: rgba(255, 255, 255, 0.8);
  text-decoration: none;
  transition: all 0.3s ease;
  border-radius: 0 25px 25px 0;
  margin-right: 1rem;
  position: relative;

  &:hover {
    background: rgba(43, 56, 87, 0.3);
    color: #ffffff;
    transform: translateX(5px);
  }

  &.active {
    background: linear-gradient(135deg, rgba(43, 56, 87, 0.4), rgba(43, 56, 87, 0.2));
    color: #ffffff;
    font-weight: 600;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      width: 4px;
      background: linear-gradient(180deg, #C5337B, #E91E63);
      border-radius: 0 2px 2px 0;
    }
  }
`;

export const NavIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.75rem;
  width: 20px;
`;

export const NavText = styled.span`
  font-size: 0.95rem;
  font-weight: 500;
`;

export const SidebarOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  display: none;

  /* Show overlay only on mobile and medium screens when sidebar is open */
  @media (max-width: 1024px) {
    display: block;
  }

  /* No overlay on large screens */
  @media (min-width: 1025px) {
    display: none;
  }
`;
